/**
 * How long a standalone login link is valid for after being sent. Found in
 * `TokenManager`'s `expiration_seconds` parameter:
 * - Default value: https://github.com/light-technology/backend/blob/develop/core/helpers/tokens.py#L8
 * - Can be overridden: https://github.com/light-technology/backend/blob/develop/apps/standalone/helpers/login.py#L17-L21
 */
export const STANDALONE_LOGIN_LINK_EXPIRATION = "20 minutes";
